<p>
  availability-code-detail works!
</p>
